import React, {Component} from 'react'
import './message.css'
import {withRouter} from 'react-router-dom'
import {post} from "../common/utils/http";
import {aisinoSuccessOperatedModal, showDeleteConfirm} from "../common/modal/AisinoModalMethod";
import moment from 'moment'
import {
    AppstoreAddOutlined,
    CheckOutlined,
    CloseOutlined,
    DownOutlined,
    EyeOutlined,
    LogoutOutlined,
    MailFilled,
    MailOutlined,
    PlusOutlined,
    SearchOutlined,
    SendOutlined,
    StarFilled,
    StarOutlined,
    TagOutlined,
    UndoOutlined
} from '@ant-design/icons';
import {
    Button, ConfigProvider,
    Divider,
    Dropdown,
    Empty,
    Form,
    Input,
    Menu,
    Modal,
    Pagination,
    Select,
    Table,
    Tooltip,
    Tree
} from 'antd';
import FormItemDatePicker from "../common/form/datePicker/FormItemDatePicker";
import FormItemTextArea from "../common/form/input/FormItemTextArea";
import {isEmpty} from "../common/utils/StringUtils";
import {disabledEndDate, disabledStartDate, endDateChange, getLanguage, startDateChange} from "../source/js/common";
import {pageItems, total} from "../constant/js/formItemNameLabel/en_US/common";
import {itemsPerPage, jumpTo} from "../constant/js/formItemNameLabel/zh_CN/message";
import {page} from "../constant/js/formItemNameLabel/en_US/message";

const { DirectoryTree } = Tree;
const commonLan = require('../constant/js/formItemNameLabel/'+getLanguage()+'/common.js');
const messageLan = require('../constant/js/formItemNameLabel/'+getLanguage()+'/message.js');

const formItemLayout = {
    labelCol: {
        xs: {
            span: 24,
        },
        sm: {
            span: 7,
        },
    },
    wrapperCol: {
        xs: {
            span: 24,
        },
        sm: {
            span: 16,
        },
    },
};
let iconStyle = {
    fontSize: "18px"
}

const columns1 = [
    {
        title: commonLan.noIndex.label,
        dataIndex: 'foundation_page_rownum_rid',
        key: 'foundation_page_rownum_rid',
        width: 75,
    },
    {
        title: messageLan.userAccount.label,
        key: 'ccode',
        dataIndex: 'ccode',
        width: 115
    },
    {
        title: messageLan.userName.label,
        dataIndex: 'cname',
        key: 'cname',
        width: 120,
        ellipsis: {
            showTitle: false,
        },
        render: data => (
            <Tooltip placement="topLeft" title={data}>
                {data}
            </Tooltip>
        ),
    },
    {
        title: messageLan.activate.label,
        dataIndex: 'istatus',
        key: 'istatus',
        width: 90,
        render: data => (
            <div>{data == 1 ? "Yes" : "No"}</div>
        ),
    },
];

class messageSysContent extends Component {
    constructor(props){
        super(props);
        const timeFormatter = sessionStorage.getItem("timeFormatter");
        this.formRef = React.createRef();
        this.formModalRef=React.createRef();
        this.columns = [
            {
                title: commonLan.noIndex.label,
                dataIndex: 'foundation_page_rownum_rid',
                key: 'foundation_page_rownum_rid',
                width: 60,
                render: (data, e, index) => (
                    <div>
                        {this.state.page1.pageSize === "" ? index + 1 : data}
                    </div>),
            },
            {
                title: messageLan.read.label,
                dataIndex: 'iread',
                key: 'iread',
                width: 70,
                render: data => (
                    <div style={{ textAlign: "center" }}>
                        {data == "1" ? <MailFilled style={iconStyle} /> : <MailOutlined style={iconStyle} />}
                    </div>),
            },
            {
                title: messageLan.messageTitle.label,
                dataIndex: 'name',
                key: 'name',
                width: 230,
                ellipsis: {
                    showTitle: false,
                },
                render: data => (
                    <Tooltip placement="topLeft" title={data}>
                        {data}
                    </Tooltip>
                ),
            },
            {
                title: () => this.state.selectedKeys[0] === "000001" ? messageLan.receiver.label : messageLan.sendUser.label,
                dataIndex: "receiveuser",
                key: 'receiveuser',
                width: 110,
                ellipsis: {
                    showTitle: false,
                },
                render: (data, record) => (
                    <Tooltip placement="topLeft" title={data}>
                        {this.state.selectedKeys[0] === "000001" ? data : record.senduser}
                    </Tooltip>
                ),
            },
            {
                title: messageLan.messageTime.label,
                dataIndex: 'createdate',
                key: 'createdate',
                width: 170,
                render: data => (
                    moment(data).format(timeFormatter)
                )
            },
            {
                title: messageLan.important.label,
                dataIndex: 'ipriority',
                key: 'ipriority',
                width: 100,
                render: (data, record) => {
                    return (
                        <div style={{ textAlign: "center" }}>
                            {data == "1" ?
                                <StarFilled style={iconStyle} onClick={() => this.handleIpriority(record)} /> :
                                <StarOutlined style={iconStyle} onClick={() => this.handleIpriority(record)} />
                            }
                        </div>
                    )
                },
            },
        ];

    }
    state = {
        selectedRowKeys: [], // 表格选中的key
        selectedRowKeys1: [], // 表格选中的key
        selectedRows: [],  //表格选中的
        selectedRows1: [],  //表格选中的
        selectedRowsAll: [],
        selectedAll: false,
        selectedKeys: ["000000"], // 结构树选中的
        loading: false,
        visible: false,     // 查询信息
        visible1: false,    // 发送信息
        visible2: false,    // 选择用户
        expandedKeys: ['000000'],   // 默认选中的树key
        noticenum: this.props.noticenum,     //树上显示未查看信息的条数
        gData:[
            {
                title: messageLan.receivedMessage.label,
                key: '000000',
                children: [
                    {
                        title: messageLan.workflowSLAMessage.label,
                        key: '2',
                    },
                    {
                        title: messageLan.businessMessage.label,
                        key: '3',
                    },
                    {
                        title: messageLan.personalMessage.label,
                        key: '4',
                    },
                    {
                        title: messageLan.systemNotification.label,
                        key: '5',
                    },
                ],
            },
            {
                title: messageLan.sentMessage.label,
                key: '000001',
            },
        ],
        userTable: [],
        params:{
            iPriority:"",
            readed:"",
            star:"",
            unread:"",
            iStatus:"",
            queryStartTime:"",
            queryEndTime:"",
            query_content:"",
            code: "",
            pageIndex: 0,
            pageSize: 10
        },
        page: {
            pageCount: 1,
            totalSize: 100,
            pageNo: 0,
            pageSize: 10
        },
        Table1: [],
        page1: {
            pageCount: 1,
            totalSize: 100,
            pageNo: 0,
            pageSize: 10
        },
        selectValue: [],
        queryUser: "",
        messageType: messageLan.CapitalAllButton.label,
        allFlag:true,
        unReadFlag:true,
        readFlag:true,
        starFlag:true,
    }


    menu = (
        <Menu onClick={this.handleMenuClick.bind(this)}>
            <Menu.Item key="1"><AppstoreAddOutlined style={{ fontSize: "16px" }} /> {messageLan.allButton.label}</Menu.Item>
            <Menu.Item key="2"><MailFilled style={{ fontSize: "16px" }} /> {messageLan.unreadButton.label}</Menu.Item>
            <Menu.Item key="3"><MailOutlined style={{ fontSize: "16px" }} /> {messageLan.readButton.label}</Menu.Item>
            <Menu.Item key="4"><StarFilled style={{ fontSize: "16px" }} /> {messageLan.importantButton.label}</Menu.Item>
        </Menu>
    );
    menuMarkedAs = (
        <Menu onClick={this.handlemMenuMarkedAsClick.bind(this)}>
            <Menu.Item key="1"><MailFilled style={{ fontSize: "16px" }} /> {messageLan.unreadButton.label}</Menu.Item>
            <Menu.Item key="2"><MailOutlined style={{ fontSize: "16px" }} /> {messageLan.readButton.label}</Menu.Item>
            <Menu.Item key="3"><StarFilled style={{ fontSize: "16px" }} /> {messageLan.importantButton.label}</Menu.Item>
            <Menu.Item key="4"><StarOutlined style={{ fontSize: "16px" }} /> {messageLan.cancelImportantButton.label}</Menu.Item>
        </Menu>
    );
    handleIpriority(record) {
        post("/notice/aos/notice/noticelist/cellClickIpriority", { "cguid": record.cguid }).then(res => {
            aisinoSuccessOperatedModal()
            this.getTableListCode(this.state.selectedKeys[0])
            this.getNoticeTree()
        })
    }
    componentDidMount() {
        this.getNoticeTree()
        this.getTableListCode("000000")
        this.state.allFlag=false
    }
    componentWillReceiveProps(nextProps){
        if(nextProps.getList.get){
            this.props.getList1()
            this.getTableListCode(nextProps.getList.code)
            this.getNoticeTree()
        }
    }
    onShowSizeChange1(current, pageSize) {
        this.setState({
            page1: { ...this.state.page1, pageSize: pageSize, pageNo: current - 1, pageCount: current },
            params:{
                ...this.state.params,
                pageIndex: current - 1,
                pageSize: pageSize
            },
        }, () => {
            this.getTableList()
        })
    }
    onShowSizeChange(current, pageSize) {
        this.setState({
            page: { ...this.state.page, pageSize: pageSize, pageNo: current - 1, pageCount: current },
        }, () => {
            this.getUserList()
        })
    }
    handleChangeQuery(e) {
        this.setState({
            queryUser: e.target.value
        })
    }
    handleSearch() {
        this.getUserList(this.state.queryUser)
    }
    handleChange(selectValue) {
        this.setState({
            selectValue
        })
    }
    onChange(page, pageSize) {
        this.setState({
            page: { ...this.state.page, pageSize: pageSize, pageNo: page - 1, pageCount: page },
        }, () => {
            this.getUserList()
        })
    }
    onChange1(page, pageSize) {
        this.setState({
            page1: { ...this.state.page1, pageSize: pageSize, pageNo: page - 1, pageCount: page },
            params:{
                ...this.state.params,
                pageIndex: page - 1,
                pageSize: pageSize
            }
        }, () => {
            this.getTableList()
        })
    }
    handleResetClick = e => {
        this.state["_endDate"]='';
        this.state["_startDate"]='';
        this.formRef.current.resetFields();
    };
    onFinish (){ //搜索消息\
        this.formRef.current.validateFields().then(values=>{
            if(!isEmpty(values.queryStartTime)){
                values.queryStartTime = values.queryStartTime.format("YYYY-MM-DD HH:mm:ss");
            }
            if(!isEmpty(values.queryEndTime)){
                values.queryEndTime = values.queryEndTime.format("YYYY-MM-DD HH:mm:ss");
            }
            this.setState({
                visible: false,
                page1: { ...this.state.page1, pageNo: 0, pageCount: 1 },
                params:{
                    ...this.state.params,
                    iPriority:"",
                    readed:"",
                    star:"",
                    unread:"",
                    iStatus:"",
                    pageIndex: 0,
                    pageSize: this.state.page1.pageSize,
                    code: this.state.selectedKeys[0],
                    queryStartTime: values.queryStartTime,
                    queryEndTime: values.queryEndTime,
                    query_content: values.query_content
                }
            }, () => {
                this.getTableList()
            });
            this.state["_endDate"]='';
            this.state["_startDate"]='';
            this.formRef.current.resetFields();
        });
    };
    onFinish1(){ //发送消息
        this.formModalRef.current.validateFields().then(values=>{
            if (this.state.selectValue.length === 0) {
                Modal.error({
                    title: messageLan.selectUser.label,
                    //   content: 'Please click the plus sign to select the user',
                });
            } else {
                let str = ""
                this.state.selectValue.forEach(item => {
                    str += ("," + item.value)
                })
                str = str.substring(1);
                post("/notice/aos/notice/noticesend/sendNotice", {
                    "sendType": "message",
                    "creplyGuid": "",
                    "orgnId": "",
                    "multiSelect": "yes",
                    "hideOrgn": "yes",
                    "toUserId": str,
                    "content": values.sendContent
                }).then(res => {
                    aisinoSuccessOperatedModal(()=>{
                        this.getTableListCode(this.state.selectedKeys[0])
                    })
                    this.setState({
                        visible1: false,
                    });
                    this.setState({
                        selectValue: []
                    })
                })
            }
        });
    };

    showModal = () => {  //搜索消息
        this.setState({
            visible: true,
        });
    };
    showModal1 = () => { //发送消息
        this.setState({
            visible1: true,
        });
    };
    showModal2 = () => { //选择用户
        this.setState({
            visible2: true,
        });
        this.getUserList()
    };
    handleExit() { //搜索消息
        this.setState({
            visible: false,
        });
        this.formRef.current.resetFields()
    }
    handleExit1() { //发送消息
        this.setState({
            visible1: false,
        });
    }
    handleExit2() { //选择用户
        this.setState({
            visible2: false,
            selectedRowKeys1: [],
            selectedRows1: [],
            queryUser:''
        });
    }
    handleCancel = e => {//搜索消息
        this.setState({
            visible: false,
        });
    };
    handleCancel1 = e => {//发送消息
        this.setState({
            visible1: false,
        });
    };
    handleCancel2 = e => {//选择用户
        this.setState({
            visible2: false,
            selectedRowKeys1: [],
            selectedRows1: [],
            queryUser:''
        });
    };
    handleOk() { //选择用户页 点击ok赋值到输入框中
        let arr = []
        if (this.state.selectedRows1.length !== 0) {
            this.state.selectedRows1.forEach((item, index) => {
                arr.push({ label: ((index+1) + "." + item.cname), value: item.cguid })
            })
        }
        this.state.selectValue = arr
        this.setState({
            visible2: false,
            selectedRowKeys1: [],
            selectedRows1: [],
        });
    }
    handlemMenuMarkedAsClick(data) {
        let ids = []
        this.state.selectedRows.forEach(item => {
            ids.push(item.cguid)
        });
        if (data.key === "1") {
            post("/notice/aos/notice/noticelist/updateReadToUnReadByStatus", {
                ids
            }).then(res => {
                    this.getTableListCode(this.state.selectedKeys[0])
                    this.getNoticeTree()
            })
        } else if (data.key === "2") {
            post("/notice/aos/notice/noticelist/updateUnReadToReadByStatus", {
                ids
            }).then(res => {
                this.getTableListCode(this.state.selectedKeys[0])
                this.getNoticeTree()
            })
        } else if (data.key === "3") {
            post("/notice/aos/notice/noticelist/markNoticeToStarMsgByIPriority", {
                ids
            }).then(res => {
                this.getTableListCode(this.state.selectedKeys[0])
                this.getNoticeTree()
            })
        } else if (data.key === "4") {
            post("/notice/aos/notice/noticelist/cancleNoticeToStarMsgByIPriority", {
                ids
            }).then(res => {
                this.getTableListCode(this.state.selectedKeys[0])
                this.getNoticeTree()
            })
        }
    }
    handleMarkRead(data) {
        let ids = []
        data.forEach(item => {
            ids.push(item.cguid)
        });
        post("/notice/aos/notice/noticelist/updateUnReadToReadByStatus", {
            ids
        }).then(res => {
            // aisinoSuccessOperatedModal()
            this.getTableListCode(this.state.selectedKeys[0])
            this.getNoticeTree()
        })
    }
    handleMenuClick(data) {
        if (data.key === "1") {
            this.getTableListCode("");
            this.state.messageType=messageLan.CapitalAllButton.label;
            this.state.allFlag=false;
            this.state.unReadFlag=true;
            this.state.readFlag=true;
            this.state.starFlag=true;
        } else if (data.key === "2") {
            this.setState({
                page1: { ...this.state.page1, pageNo: 0, pageCount: 1 },
                params:{
                    ...this.state.params,
                    iPriority:"",
                    readed:"",
                    star:"",
                    unread:"unread",
                    iStatus:"1",
                    pageIndex: 0,
                    pageSize: this.state.page1.pageSize,
                    code:"",
                    queryStartTime: "",
                    queryEndTime: "",
                    query_content: ""
                }
            }, () => {
                this.getTableList();
                this.state.messageType=messageLan.unread.label;
                this.state.unReadFlag=false;
                this.state.allFlag=true;
                this.state.readFlag=true;
                this.state.starFlag=true;
            })
        } else if (data.key === "3") {
            this.setState({
                page1: { ...this.state.page1, pageNo: 0, pageCount: 1 },
                params:{
                    ...this.state.params,
                    iPriority:"",
                    readed:"readed",
                    star:"",
                    unread:"",
                    iStatus:"0",
                    pageIndex: 0,
                    pageSize: this.state.page1.pageSize,
                    code:"",
                    queryStartTime: "",
                    queryEndTime: "",
                    query_content: ""
                }
            }, () => {
                this.getTableList();
                this.state.messageType=messageLan.read.label;
                this.state.readFlag=false;
                this.state.allFlag=true;
                this.state.unReadFlag=true;
                this.state.starFlag=true;
            })
        } else if (data.key === "4") {
            this.setState({
                page1: { ...this.state.page1, pageNo: 0, pageCount: 1 },
                params:{
                    ...this.state.params,
                    iPriority:"1",
                    readed:"",
                    star:"star",
                    unread:"",
                    iStatus:"",
                    pageIndex: 0,
                    pageSize: this.state.page1.pageSize,
                    code:"",
                    queryStartTime: "",
                    queryEndTime: "",
                    query_content: ""
                }
            }, () => {
                this.getTableList();
                this.state.messageType=messageLan.important.label;
                this.state.starFlag=false;
                this.state.allFlag=true;
                this.state.unReadFlag=true;
                this.state.readFlag=true;
            })
        }
    }
    handleDelete(data) {
        showDeleteConfirm(() => {
            let ids = []
            data.forEach(item => {
                ids.push(item.cguid)
            });
            post("/notice/aos/notice/noticelist/removeNotice", {
                ids,
                treeNode: this.state.selectedKeys[0]
            }).then(res => {
                aisinoSuccessOperatedModal()
                this.getTableListCode(this.state.selectedKeys[0])
                this.getNoticeTree()
            })
        }, () => {

        })

    }
    onSelectChange = (selectedRowKeys, selectedRows) => {
        this.setState({ selectedRowKeys, selectedRows });
    };
    onSelectChange1 = (selectedRowKeys1, selectedRows1) => {
        this.setState({ selectedRowKeys1, selectedRows1 });
    };
    onSelect = (selectedKeys, info) => {
        this.setState({
            selectedKeys,
            page1: { ...this.state.page1, pageNo: 0, pageCount: 1 },
        }, () => {
            this.getTableListCode(selectedKeys[0])
        })
    };
    getNoticeTree(){
        post("/notice/aos/notice/noticelist/getNoticeTree").then(res=>{
            let arr = []
            let children = []
            res.forEach(item=>{
                if(item.cparentid === "root"){
                    arr.push({key:item.code,title:item.cname})
                }
                if(item.cparentid === "000000"){
                    children.push({key:item.code,title:item.cname})
                }
            })
            arr.forEach(item=>{
                if(item.key === "000000"){
                    item.children = children
                }
            })
            this.setState({
                gData: arr
            })
        })
    }
    getTableList() {
        post("/notice/aisino/notice/getNoticeList", this.state.params).then(res => {
            let arr = []
            res.records.forEach((item, index) => {
                if (item.foundation_page_rownum_rid) {
                    arr.push({ ...item, key: item.foundation_page_rownum_rid })
                    return false;
                }
                arr.push({ ...item, key: index })
            })
            this.setState({
                Table1: arr,
                page1: { ...this.state.page1, totalSize: res.Page.totalSize },
                selectedRowKeys: [],
                selectedRows: [],
                selectedRowsAll: [],
                selectedAll: false,
            })
            // this.props.handleMsgNum()
        })
    }
    getTableListCode(code) {
        post("/notice/aisino/notice/getNoticeList", {code,pageIndex:0,pageSize:this.state.page1.pageSize}).then(res => {
            let arr = []
            res.records.forEach((item, index) => {
                if (item.foundation_page_rownum_rid) {
                    arr.push({ ...item, key: item.foundation_page_rownum_rid })
                    return false;
                }
                arr.push({ ...item, key: index })
            })
            this.setState({
                Table1: arr,
                page1: { ...this.state.page1, totalSize: res.Page.totalSize,pageCount: 1 },
                selectedRowKeys: [],
                selectedRows: [],
                selectedRowsAll: [],
                selectedAll: false,
                params:{
                    iPriority:"",
                    readed:"",
                    star:"",
                    unread:"",
                    iStatus:"",
                    queryStartTime:"",
                    queryEndTime:"",
                    query_content:"",
                    code: code,
                    pageNo:0,
                    pageSize: this.state.page1.pageSize,
                    pageCount: 1
                },
            })
        })
    }
    getUserList(ccode) {
        post("aos/rms/userchooser/getUserListByOrgnId", {
            "nodeIds": "1",
            "pageIndex": this.state.page.pageNo,
            pageSize: this.state.page.pageSize,
            "sortField": "",
            "sortOrder": "",
            ccode
        }).then(res => {
            let arr = []
            res.records.forEach(item => {
                arr.push({ ...item, key: item.cguid })
            })
            this.setState({
                userTable: arr,
                page: { ...this.state.page, totalSize: res.Page.totalSize }
            })
        })
    }
    render() {
        const { selectedRowKeys, selectedRowKeys1, selectedRows, messageType, allFlag, unReadFlag, readFlag, starFlag } = this.state;
        const rowSelection = {
            type: "checkbox",
            selectedRowKeys,
            onChange: this.onSelectChange,
            onSelectAll: (selectedAll, selectedRowsAll, changeRows) => {
                this.setState({ selectedAll, selectedRowsAll })
            }
        };
        const rowSelection1 = {
            type: "checkbox",
            selectedRowKeys1,
            onChange: this.onSelectChange1,
        };
        return (
            <div style={{ height: "90%" }} className="messageSwiper">
                <div>
                    <Button disabled={selectedRows.length != 1} type="text" onClick={() => { this.props.handleView(selectedRows[0], this.state.selectedKeys[0]) }}><EyeOutlined />{commonLan.viewButton.label}</Button>
                    <Button type="text" disabled={!selectedRows.length} onClick={() => { this.handleDelete(selectedRows) }}><CloseOutlined />{commonLan.deleteButton.label}</Button>
                    <Button type="text" onClick={() => { this.getTableListCode("000000") }}><UndoOutlined />{commonLan.refreshButton.label}</Button>
                    |
                    <Button type="text" onClick={() => this.showModal()}><SearchOutlined />{commonLan.searchButton.label}</Button>
                    <span hidden={allFlag}>
                        <Dropdown overlay={this.menu} disabled={this.state.selectedKeys[0] === "000001"} trigger={['click']}>
                            <Button type="text" >
                                <AppstoreAddOutlined /> {messageType} <DownOutlined />
                            </Button>
                        </Dropdown>
                    </span>
                    <span hidden={unReadFlag}>
                        <Dropdown overlay={this.menu} disabled={this.state.selectedKeys[0] === "000001"} trigger={['click']} >
                            <Button type="text">
                                <MailFilled /> {messageType} <DownOutlined />
                            </Button>
                        </Dropdown>
                    </span>
                    <span hidden={readFlag}>
                        <Dropdown overlay={this.menu} disabled={this.state.selectedKeys[0] === "000001"} trigger={['click']} >
                            <Button type="text">
                                <MailOutlined /> {messageType} <DownOutlined />
                            </Button>
                        </Dropdown>
                    </span>
                    <span hidden={starFlag}>
                        <Dropdown overlay={this.menu} disabled={this.state.selectedKeys[0] === "000001"} trigger={['click']} >
                            <Button type="text">
                                <StarFilled /> {messageType} <DownOutlined />
                            </Button>
                        </Dropdown>
                    </span>
                    <Button
                        type="text"
                        onClick={() => { this.handleMarkRead(selectedRows) }}
                        disabled={!selectedRows.length || this.state.selectedKeys[0] === "000001"}
                    >
                        <TagOutlined />{messageLan.markReadButton.label}
                    </Button>
                    <Dropdown overlay={this.menuMarkedAs} disabled={!selectedRows.length || this.state.selectedKeys[0] === "000001"} trigger={['click']}>
                        <Button type="text">
                            <TagOutlined />{messageLan.markedAsButton.label}<DownOutlined />
                        </Button>
                    </Dropdown>
                    {/*|*/}
                    {/*<Button type="text" onClick={() => this.showModal1()}><SendOutlined />{messageLan.SendMessageButton.label}</Button>*/}
                    |
                    <Button type="text" onClick={() => { this.props.handleExit() }}><LogoutOutlined />{messageLan.exitButton.label}</Button>
                </div>
                <div className="row" style={{ height: "100%" }}>
                    <div className="colTree" style={{ border: "1px solid #ccc" }}>
                        <DirectoryTree
                            icon={false}
                            multiple
                            expandAction={false}
                            defaultSelectedKeys={["000000"]}
                            style={{ padding: "10px 10px 0 0" }}
                            className="draggable-tree"
                            defaultExpandedKeys={this.state.expandedKeys}
                            blockNode
                            onSelect={this.onSelect}
                            treeData={this.state.gData}
                        />
                    </div>
                    <div className="colTable">
                        <div style={{ border: "1px solid #ccc", margin: "0 0 7px 4px", height: "540px" }}>
                            <div style={{ borderBottom: "1px solid #ccc", margin: "0 0 40px 0", height: "430px" }}>
                                <ConfigProvider
                                    renderEmpty={() => (
                                        <Empty
                                            image={Empty.PRESENTED_IMAGE_SIMPLE}
                                            description={commonLan.noData}
                                        />
                                    )}
                                >
                                    <Table
                                        scroll={{ y: 390 }}
                                        rowSelection={rowSelection}
                                        size={"small"}
                                        columns={this.columns}
                                        dataSource={this.state.Table1}
                                        pagination={false}
                                        onRow={record => {
                                            return {
                                                onDoubleClick: () => {
                                                    this.props.handleView(record, this.state.selectedKeys[0])
                                                }
                                            };
                                        }}
                                        rowClassName={(record, index) => {
                                            let className = 'light-row';
                                            if (index % 2 === 1) className = 'dark-row';
                                            return className;
                                        }}
                                    />
                                </ConfigProvider>
                            </div>
                            <Pagination
                                style={{ marginLeft: "20px" }}
                                size="small"
                                onShowSizeChange={this.onShowSizeChange1.bind(this)}
                                showTotal={total => commonLan.total+' '+total+' '+commonLan.pageItems.label}
                                total={this.state.page1.totalSize}
                                showSizeChanger
                                showQuickJumper
                                onChange={this.onChange1.bind(this)}
                                pageSizeOptions={[10, 50, 100, 500, 1000]}
                                current={this.state.page1.pageCount}
                                locale={{
                                    items_per_page: messageLan.itemsPerPage.label,
                                    jump_to: messageLan.jumpTo.label,
                                    page: messageLan.page.label
                                }}
                            />
                        </div>
                    </div>
                </div>
                <Modal  //=============================================================================================搜索消息
                    title={messageLan.messageInquiry.label}
                    footer={null}
                    bodyStyle={{ padding: "0 20px 30px 20px" }}
                    maskClosable={false}
                    maskStyle={{ background: "rgba(255,255,255,0.7)" }}
                    visible={this.state.visible}
                    onCancel={this.handleCancel}
                >
                    <div>
                        <Form ref={this.formRef} name="time_related_controls" {...formItemLayout} >
                            <div style={{ borderBottom: "1px #f0f0f0 solid", marginBottom: "20px", padding: "5px" }}>
                                <Button type="text" onClick={() => this.onFinish()} ><SearchOutlined />{messageLan.searchButton.label}</Button>
                                <Button type="text" onClick={this.handleResetClick}><UndoOutlined />{messageLan.clearButton.label}</Button>
                                <Button type="text" onClick={() => this.handleExit()}><LogoutOutlined />{messageLan.lowerExitButton.label}</Button>
                            </div>
                            <FormItemDatePicker showTime  name="queryStartTime" label={messageLan.startTime.label}
                                                disabledDate={(current)=>disabledStartDate(current,this,null,null,true)}
                                                onChange={(date,dateString)=>startDateChange(date,dateString,this)} />
                            <FormItemDatePicker showTime name="queryEndTime" label={messageLan.endTime.label}
                                                disabledDate={(current)=>disabledEndDate(current,this,null,null,true)}
                                                onChange={(date,dateString)=>endDateChange(date,dateString,this)} />
                            <div style={{paddingLeft:'12px'}}>
                                <FormItemTextArea label={messageLan.messageContent.label} name="query_content" />
                            </div>
                        </Form>
                    </div>
                </Modal>
                <Modal  //=============================================================================================发送消息
                    title={messageLan.SendAMessageButton.label}
                    footer={null}
                    bodyStyle={{ padding: "0 20px 30px 20px" }}
                    maskClosable={false}
                    destroyOnClose={true}
                    maskStyle={{ background: "rgba(255,255,255,0.7)" }}
                    visible={this.state.visible1}
                    onCancel={this.handleCancel1}
                >
                    <div>
                        <Form ref={this.formModalRef} name="nest-messages" initialValues={{ remember: true, }}>
                            <div style={{ borderBottom: "1px #f0f0f0 solid", marginBottom: "20px", padding: "5px" }}>
                                <Button type="text" onClick={() => this.onFinish1()} ><SendOutlined />{messageLan.sendButton.label}</Button>
                                <Button type="text" onClick={() => this.handleExit1()}><LogoutOutlined />{messageLan.lowerExitButton.label}</Button>
                            </div>
                            <Form.Item name="userSelect">
                                <Select
                                    labelInValue={true}
                                    mode="multiple"
                                    style={{ width: '85%', display: "inline-block" }}
                                    dropdownStyle={{ display: "none" }}
                                    value={this.state.selectValue}
                                    onChange={this.handleChange.bind(this)}
                                />
                                <PlusOutlined style={{ fontSize: '24px', marginLeft: "15px" }} onClick={() => this.showModal2()} />
                            </Form.Item>
                            <Form.Item name="sendContent" rules={[{ required: true }]}>
                                <Input.TextArea style={{ width: '55%', height: "300px" }} />
                            </Form.Item>
                        </Form>
                    </div>
                    <Modal   //=============================================================================================选择用户
                        title={messageLan.pleaseSelectUser.label}
                        footer={null}
                        forceRender={true}
                        bodyStyle={{ padding: "0 20px 30px 20px" }}
                        maskClosable={false}
                        destroyOnClose={true}
                        maskStyle={{ background: "rgba(255,255,255,0.7)" }}
                        visible={this.state.visible2}
                        onCancel={this.handleCancel2}
                    >
                        <div style={{ borderBottom: "1px #f0f0f0 solid", marginBottom: "20px", padding: "5px" }}>
                            <Button type="text" onClick={() => { this.handleOk() }}><CheckOutlined />{messageLan.okButton.label}</Button>
                            <Button type="text" onClick={() => this.handleExit2()}><LogoutOutlined />{messageLan.lowerExitButton.label}</Button>
                        </div>
                        <Divider orientation="left" style={{ margin: "none!important", color: "#ccc" }}>{messageLan.searchCondition.label}</Divider>
                        <div style={{ border: "1px #f0f0f0 solid", borderTop: "none", margin: "-11px 0 10px  0", padding: "17px 20px" }}>
                            {messageLan.queryUser.label}<Input style={{ width: "40%", margin: "0 10px" }} onChange={(e) => this.handleChangeQuery(e)} />
                            <Button type="text" onClick={() => { this.handleSearch() }}><SearchOutlined />{commonLan.searchButton.label}</Button>
                        </div>
                        <div style={{ border: "1px #f0f0f0 solid", marginBottom: "10px" }}>
                            <Table
                                size={"small"}
                                scroll={{ y: 433 }}
                                rowSelection={rowSelection1}
                                columns={columns1}
                                dataSource={this.state.userTable}
                                pagination={false}
                            />
                        </div>
                        <Pagination
                            size="small"
                            total={this.state.page.totalSize}
                            showSizeChanger
                            showQuickJumper
                            onChange={this.onChange.bind(this)}
                            onShowSizeChange={this.onShowSizeChange.bind(this)}
                            pageSizeOptions={[10, 100, 500, 1000]}
                        />
                    </Modal>
                </Modal>

            </div>
        )
    }
}
export default withRouter(messageSysContent)

